;(function () {
  if (window.__prefetchInit) return
  window.__prefetchInit = true

  function init() {
    if (!document.createElement('link').relList.supports('prefetch')) return
    var conn = navigator.connection
    if (conn && (conn.saveData || (conn.effectiveType || '').indexOf('2g') !== -1)) return
    var chrome = navigator.userAgent.match(/Chrome\/(\d+)/)
    if (chrome && parseInt(chrome[1], 10) < 110) return

    var done = new Set()
    var skipPaths = ['/cart', '/checkout', '/checkouts/', '/account', '/admin', '/apps/', '/tools/']
    var hoverTimer = null
    var lastTouch = 0

    function eligible(a) {
      if (!a || !a.href || a.origin !== location.origin) return false
      if (a.protocol !== location.protocol) return false
      if (a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-no-prefetch')) return false
      if (a.search) return false
      if (a.pathname === location.pathname) return false
      for (var i = 0; i < skipPaths.length; i++) {
        if (a.pathname.indexOf(skipPaths[i]) !== -1) return false
      }
      return true
    }

    function prefetch(url, priority) {
      if (done.has(url)) return
      done.add(url)
      var l = document.createElement('link')
      l.setAttribute('data-optimizer', '')
      l.rel = 'prefetch'
      l.as = 'document'
      l.href = url
      if (priority) l.fetchPriority = priority
      document.head.appendChild(l)
    }

    function linkFrom(e) {
      return e.target && e.target.closest ? e.target.closest('a[href]') : null
    }

    document.addEventListener('touchstart', function (e) {
      lastTouch = performance.now()
      var a = linkFrom(e)
      if (eligible(a)) prefetch(a.href, 'high')
    }, { capture: true, passive: true })

    document.addEventListener('mouseover', function (e) {
      if (performance.now() - lastTouch < 1111) return
      var a = linkFrom(e)
      if (!eligible(a)) return
      clearTimeout(hoverTimer)
      hoverTimer = setTimeout(function () { prefetch(a.href, 'high') }, 65)
      a.addEventListener('mouseout', function (ev) {
        if (ev.relatedTarget && a.contains(ev.relatedTarget)) return
        clearTimeout(hoverTimer)
      }, { once: true, passive: true })
    }, { capture: true, passive: true })
  }

  if (document.readyState === 'complete') init()
  else window.addEventListener('load', init, { once: true })
})()